module.exports = __webpack_public_path__ + "media/country_flags/ni-b6afc5eb.png";